import styled from 'styled-components';

export const DoughnutWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 12px 28px;
    padding: 4px 0 8px;
`;

export const DoughnutCanvasWrap = styled.div`
    position: relative;
    flex: 0 0 auto;
    width: min(100%, 280px);
    height: 252px;
    max-width: 280px;
`;

/** Três colunas iguais: percentuais + mini-barras */
export const DoughnutFooter = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px 12px;
    padding: 12px 8px 6px;
    margin-top: 4px;
    border-top: 1px solid rgba(242, 146, 5, 0.12);
`;

export const DoughnutFooterBlock = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
`;

export const DoughnutFooterTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 0.78rem;
    font-weight: 600;
    color: rgba(200, 210, 235, 0.88);

    i {
        font-size: 0.55rem;
        flex-shrink: 0;
    }

    .pct-value {
        font-variant-numeric: tabular-nums;
        color: rgba(240, 244, 255, 0.96);
        font-weight: 700;
    }
`;

export const DoughnutFooterMiniTrack = styled.div`
    width: 100%;
    height: 7px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.38);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.45);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.07);
`;

export const DoughnutFooterMiniFill = styled.div`
    height: 100%;
    border-radius: 4px;
    transition: width 0.35s ease;
`;
